import logo from './logo.svg';
import './App.css';
import UserTable from "./components/UserTable";
import DayView from "./components/DayView";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DayViewThiru from "./components/DayViewThiru";


function App1() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

function App2() {
  return (
    <div>
      <DayView />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DayViewThiru />} />
        <Route path="/day" element={<DayView />} />
        <Route path="/day-thiru" element={<DayViewThiru />} />
        {/*<Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />*/}
      </Routes>
    </Router>
  );
}

export default App;
